import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const SESSION_KEY = "af_session_token";

export function getSessionToken() {
  return localStorage.getItem(SESSION_KEY);
}

async function ensureSession() {
  let token = getSessionToken();
  if (token) return token;
  const { data } = await axios.post(`${API}/session`);
  token = data.session_token;
  localStorage.setItem(SESSION_KEY, token);
  return token;
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use(async (config) => {
  const token = await ensureSession();
  config.headers["X-Session-Token"] = token;
  return config;
});

// Self-heal: if the server no longer recognizes our session token (e.g. it
// was cleared/reset server-side), mint a fresh one and retry the request
// once instead of failing forever with a stale token stuck in localStorage.
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (error.response && error.response.status === 401 && config && !config._retried401) {
      config._retried401 = true;
      localStorage.removeItem(SESSION_KEY);
      const token = await ensureSession();
      config.headers["X-Session-Token"] = token;
      return api.request(config);
    }
    return Promise.reject(error);
  }
);

export async function fetchVehiculos() {
  const { data } = await axios.get(`${API}/vehiculos-destacados`);
  return data.vehiculos;
}

export async function saveLead(payload) {
  const { data } = await api.post(`/leads`, payload);
  return data;
}

export async function sendOtp(phone) {
  const { data } = await api.post(`/otp/send`, { phone });
  return data;
}

export async function verifyOtp(phone, code) {
  const { data } = await api.post(`/otp/verify`, { phone, code });
  return data;
}

export async function getResultados() {
  const { data } = await api.get(`/resultados`);
  return data;
}

const OPERATION_KEY = "af_operation_id";
export function getOperationId() {
  let x = localStorage.getItem(OPERATION_KEY);
  if (!x) {
    x = (crypto.randomUUID && crypto.randomUUID()) || `op-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(OPERATION_KEY, x);
  }
  return x;
}
export function resetOperation() {
  localStorage.removeItem(OPERATION_KEY);
}

export async function startConsulta() {
  const operation_id = getOperationId();
  const { data } = await api.post(`/consultas`, { operation_id });
  return data;
}

export async function getMisTramites() {
  const { data } = await api.get(`/tramites`);
  return data.tramites;
}

export async function getTramiteById(id) {
  const { data } = await api.get(`/tramites/${id}`);
  return data.tramite;
}

export async function registrarInteres(idProducto) {
  const { data } = await api.post(`/resultados/interes`, { id_producto: idProducto });
  return data;
}

export async function seleccionarOferta(idProducto) {
  const operation_id = getOperationId();
  const { data } = await api.post(`/tramites/seleccionar`, { id_producto: idProducto, operation_id });
  return data;
}

export async function getTramite() {
  const { data } = await api.get(`/tramites/me`);
  return data.tramite;
}

export async function uploadDocumento(tramiteId, idDoc, file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post(`/tramites/${tramiteId}/documentos/${idDoc}/upload`, form,
    { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

export async function reingresoSend(phone) {
  const { data } = await api.post(`/reingreso/otp/send`, { phone });
  return data;
}
export async function reingresoVerify(phone, code) {
  const { data } = await api.post(`/reingreso/otp/verify`, { phone, code });
  return data;
}
export async function reingresoSeleccionar(tramiteId) {
  const { data } = await api.post(`/reingreso/seleccionar`, { tramite_id: tramiteId });
  return data;
}
